import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "TUIKit-navbar"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "TUIKit-main-container" }
const _hoisted_4 = {
  key: 0,
  class: "TUIKit-main"
}
const _hoisted_5 = {
  key: 0,
  class: "TUIKit-main-aside"
}
const _hoisted_6 = {
  key: 1,
  class: "TUIKit-main-main"
}
const _hoisted_7 = {
  key: 1,
  class: "TUIKit-main"
}

import { ref, onMounted, framework } from './adapter-vue';
import { TUILogin } from '@tencentcloud/tui-core';
import { TUIStore, StoreName, TUIConversationService, TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import { TUISearch, TUIConversation, TUIChat, TUIContact, TUIGroup } from './components';
import { isH5 } from './utils/env';
import axios from "axios"

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  // When deploying a production environment, you do not need to pass in SDKAppID, userID, and userSig through props.
  // eslint-disable-next-line vue/prop-name-casing
  SDKAppID: {
    type: Number,
    default: 0,
    required: false,
  },
  userID: {
    type: String,
    default: '',
    required: false,
  },
  userSig: {
    type: String,
    default: '',
    required: false,
  },
  conversationID: {
    type: String,
    default: '',
    required: false, // When integrating Chat independently, you need to pass the conversationID
  },
},
  setup(__props) {

const currentConversationID = ref<string>('');
const currentNavbar = ref<string>('message');
const currentLanguage = ref<string>('zh');
const navbarList = [
  {
    id: 'message',
    label: '消息',
  },
  // {
  //   id: 'contact',
  //   label: '通讯录',
  // },
];

const props = __props;

onMounted(() => {
  TUIStore.watch(StoreName.CONV, {
    currentConversationID: (id: string) => {
      currentConversationID.value = id;
    },
  });

  // Default login logic
  login();

  // init language by SDKAppID
  initLanguage();

  // Modify CallKit style in H5 environment
  modifyCallKitStyle();
});

function login() {
     //创建实例

    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const paramValue = params.get('id');
    // alert(paramValue)
    let userSig = ""
    let userID = paramValue
    axios
      .post("https://minice.charityzimi.cn/api/v1/im/token", {
        user_id: paramValue,
      })
      .then((res2) => {
        // alert(1);
        // console.log(document.querySelector("#im"))
console.log(res2)
console.log("res2")
        userSig = res2.data.data.UserSig;
       const { SDKAppID,  conversationID } = props;
      // alert(2)
// alert(res2.data.UserSig)
  if (SDKAppID && userID && userSig) {
    // alert(1)
    TUILogin.login({
      SDKAppID,
      userID,
      userSig,
      useUploadPlugin: true,
      framework,
    }).then((res) => {
        console.log(res)
        console.log("是否登录成功")
      // Execute the following code when integrating Chat independently
      if (conversationID.startsWith('C2C') || conversationID.startsWith('GROUP')) {
        TUIConversationService.switchConversation(conversationID);
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    }).catch((error) => { });
  }
        // console.log(res)
      });

    console.log(props)
      console.log("是否登录成功")
  
}

function isIntlSDKAppID(SDKAppID: number) {
  if ((SDKAppID === 0)
    || (SDKAppID >= 20000000 && SDKAppID < 90000000)
    || (SDKAppID >= 1720000000 && SDKAppID < 1790000000)) {
    return true;
  }
  return false;
}

function initLanguage() {
  currentLanguage.value = isIntlSDKAppID(props.SDKAppID) ? 'en' : 'zh';
  TUITranslateService.changeLanguage(currentLanguage.value);
}

function modifyCallKitStyle() {
  if (isH5) {
    const bodyStyle = document.getElementsByTagName('body')[0].style;
    bodyStyle.setProperty('--callLeft', '0');
    bodyStyle.setProperty('--callTop', '0');
    bodyStyle.setProperty('--callWidth', '100%');
    bodyStyle.setProperty('--callHeight', '100%');
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { key: _unref(currentLanguage) }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createElementVNode("div", {
        class: _normalizeClass(['TUIKit', _unref(isH5) && 'TUIKit-h5'])
      }, [
        (!(_unref(isH5) && _unref(currentConversationID)))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navbarList, (item) => {
                return _createElementVNode("div", {
                  key: item.id,
                  class: _normalizeClass(['TUIKit-navbar-item', _unref(currentNavbar) === item.id && 'TUIKit-navbar-item-active']),
                  onClick: ($event: any) => (currentNavbar.value = item.id)
                }, _toDisplayString(_unref(TUITranslateService).t(item.label)), 11, _hoisted_2)
              }), 64))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          (_unref(currentNavbar) === 'message')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (!(_unref(isH5) && _unref(currentConversationID)))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_unref(TUISearch), { searchType: "global" }),
                      _createVNode(_unref(TUIConversation))
                    ]))
                  : _createCommentVNode("", true),
                (!_unref(isH5) || _unref(currentConversationID))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_unref(TUIChat), null, {
                        default: _withCtx(() => [
                          _createElementVNode("h1", null, _toDisplayString(_unref(TUITranslateService).t('欢迎使用')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(TUIGroup), {
                        class: _normalizeClass(_unref(isH5) ? 'chat-popup' : 'chat-aside')
                      }, null, 8, ["class"]),
                      _createVNode(_unref(TUISearch), {
                        class: _normalizeClass(_unref(isH5) ? 'chat-popup' : 'chat-aside'),
                        searchType: "conversation"
                      }, null, 8, ["class"])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isH5) && !_unref(currentConversationID))
                  ? (_openBlock(), _createBlock(_unref(TUIGroup), {
                      key: 2,
                      class: "chat-popup"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(TUIContact), { displayType: "selectFriend" })
              ]))
            : (_unref(currentNavbar) === 'contact')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_unref(TUIContact), {
                    displayType: "contactList",
                    onSwitchConversation: _cache[0] || (_cache[0] = ($event: any) => (currentNavbar.value = 'message'))
                  })
                ]))
              : _createCommentVNode("", true)
        ])
      ], 2)
    ])
  ]))
}
}

})